import { createRouter, createWebHashHistory as history } from "vue-router";
import Home from "@/views/Home.vue";
import Projects from "@/views/Projects.vue";
import Clients from "@/views/Clients.vue";
import About from "@/views/About.vue";
import Contact from "@/views/Contact.vue";
import ProjectPage from "@/views/ProjectPage.vue";
import NotFound from "@/views/NotFound.vue";
import Policies from "@/views/Policies.vue";
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/projects",
    name: "Projects",
    component: Projects,
  },
  {
    path: "/projects/:id",
    name: "ProjectPage",
    component: ProjectPage,
    props: true,
  },
  {
    path: "/clients",
    name: "Clients",
    component: Clients,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/policies",
    name: "Policies",
    component: Policies,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
  },
];

const router = createRouter({
  history: history(),
  routes,
  // historyApiFallback: true
});

export default router;
